import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { url } from '../../utils/variables';
import {getDirection, pexios, uploadImages} from '../../utils/functions';
import Moment from 'moment-jalaali';
import ImagePickerModal from '../../components/master/ImagePickerModal';
import Modal from '../../components/master/Modal';
import addImage from '../../assets/images/add_image.png';

import ImageZoom from '../../components/master/ImageZoom';
import { useTranslation } from 'react-i18next';

export default function RegisterSingle() {

    const { t, i18n } = useTranslation();
    const { id } = useSelector(store => store.routerData);
    const { user } = useSelector((store) => store);

    const [register, setRegister] = useState({
        attachments: [],
        user: {},
    });
    const [car, setCar] = useState({});
    const [imgUid, setImgUid] = useState(null);

    const getElement = useCallback(async (data) => {
        let carData = {};
        const keys = [
            'type',
            'brand',
            'model',
            'color',
        ];
        const getElementApi = async(i) => {
            await pexios(`api/get_car_${keys[i]}_by_id`, 'post', { id: data[`car_${keys[i]}_id`] })
                .then(res => {
                    carData = { ...carData, [keys[i]]: res.data.name };
                });
        }
        for (let i = 0; i < 4; i++) {
            await getElementApi(i);
        }
        return carData;
    }, []);

    useEffect(() => {
        pexios('api/v2/get_register','post',{ id })
            .then(res => {
                const register = res.data.data;
                setRegister(register);
                getElement(register.car)
                    .then(res => setCar(res));
        })
    }, [getElement, id]);

    function finishUpload(image, done) {
        let extraImages = register.attachments.filter(itm => (
            itm.filename.includes(`${user.type === 'expert' ? 'expert_' : ''}extra`)
        ));
        if (user.type === 'user') {
            extraImages = extraImages.filter(itm => (
                !itm.filename.includes('expert')
            ));
        }
        const extraImagesCount = extraImages.length + 1;
        uploadImages({
            id,
            type: 'register',
            name: `expert_extra${extraImagesCount}`,
            image,
            done,
            callback: (data) => {
                setRegister(prevState => ({
                    ...prevState,
                    attachments: [
                        ...prevState.attachments,
                        data,
                    ],
                }));
            },
        });
    }
    const allImages = [
        {key: t('Vehicle plate'), value: 'plate'},
        {key: t('Vehicle card'), value: 'vehicle_card'},
        {key: t('Vehicle card back'),value: 'vehicle_card_back'},
        {key: t('Front vehicle'), value: 'car-front'},
        {key: t('Back vehicle'), value: 'car-back'},
        {key: t('Left side vehicle'), value: 'car-left'},
        {key: t('Right side vehicle'), value: 'car-right'},
        {key: t('Motor image'), value: 'motor'},
        {key: t('Kilometr image'), value: 'kilometer'},
        {key: t('Dashboard'), value: 'dashboard' },
        {key: t('Cabin'), value: 'cabin'},
        {key: t('Green card'),value: 'green_card'},
        {key: t('Car ceiling'),value: 'car-ceiling'},
        {key: t('Trunk'),value: 'trunk'},
        {key: t('Tire'),value: 'tire'},
        {key: t('Using'),value: 'using'},
        {key: t('Completment image'),value:  'extra'},
        {key: t('Engraved chassis number'), value: 'chassis'},
        {key: t('Front glass'), value: 'front_glass'},
        {key: t('Plate chassis'), value: 'plate_chassis'},
        {key: t('Back glass'), value: 'back_glass'},
        {key: t('Under trunk'),value: 'under_trunk'},
        {key: t('Crash image'),value: 'damage'},
    ];
    return (
        <div className='content'>
            <Modal visible={imgUid}>
                <div className='image-modal'>
                    <i className='fas fa-times'
                       onClick={() => setImgUid(null)}
                    />
                    <ImageZoom imgUid={imgUid}/>
                </div>
            </Modal>
            <div className='report' data-dir={getDirection(i18n.language)}>
                <div className='box'>
                    <p className='title'>{t('File Details')}</p>
                    <div className='textParent'>
                        <div className='text'>{t('File Num')}:</div>
                        <div className='text text-left'>{register.id}</div>
                    </div>
                    <div className='textParent'>
                        <div className='text'>{t('Date and Time of accident')}:</div>
                        <div className='text text-left'>{Moment(register.created_at).format('jYYYY/jM/jD HH:mm')}</div>
                    </div>
                    <div className='textParent'>
                        <div className='text'>{t('Visit type')}:</div>
                        <div className='text text-left'>{register.type}</div>
                    </div>
                    <div className='textParent'>
                        <div className='text'>{t('Name of applicant')}:</div>
                        <div className='text text-left'>{register.user.full_name}</div>
                    </div>
                    <div className='textParent'>
                        <div className='text'>{t('Insurer fullname')}:</div>
                        <div className='text text-left'>{register.insurance_owner_name}</div>
                    </div>
                    <div className='textParent'>
                        <div className='text'>{t('Insurer national id')}:</div>
                        <div className='text text-left'>{register.insurance_owner_national_id}</div>
                    </div>
                </div>
                <div className='box'>
                    <p className='title'>{t('Vehicle info')}</p>
                    <div className='textParent'>
                        <div className='text'>{t('Vehicle type')}:</div>
                        <div className='text text-left'>{car.type}</div>
                    </div>
                    <div className='textParent'>
                        <div className='text'>{t('Vehicle brand')}:</div>
                        <div className='text text-left'>{car.brand}</div>
                    </div>
                    <div className='textParent'>
                        <div className='text'>{t('Vehicle model')}:</div>
                        <div className='text text-left'>{car.model}</div>
                    </div>
                    <div className='textParent'>
                        <div className='text'>{t('Vehicle color')}:</div>
                        <div className='text text-left'>{car.color}</div>
                    </div>
                    <div className='textParent'>
                        <div className='text'>{t('Vehicle value')}:</div>
                        <div className='text text-left'>{register.insurance_value}</div>
                    </div>
                </div>
                <div className='box'>
                    <p className='title'>{t('File image')}</p>
                    <div className='imageBox'>
                        {
                            register.attachments.map(img=>{
                                return(
                                    <div className='imageParent register-image-parent' key={img.id}>
                                        <img
                                            onClick={() => setImgUid(img.uid)}
                                            src={`${url}/files?uid=${img.uid}&width=200&height=200`}
                                            alt='img'
                                        />
                                        {
                                            ///bcz it include vehicle_card had to separate
                                            img.filename === 'vehicle_card_back' || img.filename === 'expert_vehicle_card_back' ? 
                                            <p className='image-label'>
                                                {t('Vehicle card back')}
                                            </p>
                                            :
                                            img.filename === 'plate_chassis' || img.filename === 'expert_plate_chassis' ? 
                                            <p className='image-label'>
                                                {t('Plate chassis')}
                                            </p>
                                            :
                                            img.filename === 'under_trunk' || img.filename === 'expert_under_trunk' ? 
                                            <p className='image-label'>
                                                {t('Under trunk')}
                                            </p>
                                            :
                                            <p className='image-label'>
                                                {allImages.map((itm)=> img.filename.includes(itm.value) && itm.key)}
                                                {/* {allImages.map((itm)=>  itm.value === img.filename ? itm.key : img.filename.includes('extra') && img.filename.includes(itm.value) ? itm.key : img.filename.includes('damage') && img.filename.includes(itm.value) && itm.key)} */}
                                            </p>
                                        }
                                    </div>
                                )
                            })
                        }
                        <div className='imageParent register-image-parent'>
                            <ImagePickerModal
                                renderBtn={<img src={addImage} alt='img'/>}
                                upload={finishUpload}
                            />
                            <p className='image-label'>{t('Completment image')}</p>
                        </div>
                    </div>
                </div>
                <div className='box'>
                    <p className='title'>{t('Extra accessories list')}</p>
                    {
                        JSON.parse(register.accessories || '[]').map((itm, index) => {
                            return (
                                <div className='textParent' key={index}>
                                    <div className='text'>{itm.name}:</div>
                                    <div className='text text-left'>{itm.price} {t('rial')}</div>
                                </div>
                            );
                        })
                    }
                    {JSON.parse(register.accessories || '[]').length === 0 &&
                        <p className='empty-text'>
                            {t('Nothing registered')}
                        </p>
                    }
                </div>
                <div className='box'>
                    <p className='title'>{t('Damage accessories list')}</p>
                    {
                        JSON.parse(register.damages || '[]').map((itm, index) => {
                            return (
                                <div className='textParent' key={index}>
                                    <div className='text'>{itm.name}:</div>
                                    <div className='text text-left'>{itm.price} {t('Percent')}</div>
                                </div>
                            );
                        })
                    }
                    {JSON.parse(register.damages || '[]').length === 0 &&
                        <p className='empty-text'>
                            {t('Nothing registered')}
                        </p>
                    }
                </div>
                <div className='box'>
                    <p className='title'>{t('Exchange accessories list')}</p>
                    {
                        JSON.parse(register.rebuilds || '[]').map((itm, index) => {
                            return (
                                <div className='textParent' key={index}>
                                    <div className='text'>{itm.name}:</div>
                                    <div className='text text-left'>{itm.price} {t('Degree')}</div>
                                </div>
                            );
                        })
                    }
                    {JSON.parse(register.rebuilds || '[]').length === 0 &&
                        <p className='empty-text'>
                            {t('Nothing registered')}
                        </p>
                    }
                </div>
            </div>
        </div>
    );

}
